import script from "./Binding_CheckAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./Binding_CheckAccount.vue?vue&type=script&setup=true&lang=js"

import "./Binding_CheckAccount.vue?vue&type=style&index=0&id=03519560&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03519560"]])

export default __exports__